import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M14.6928 3H9.2982C8.30919 3 7.5 3.80984 7.5 4.79964V20.0966C7.5 20.8974 8.47103 21.3023 9.03746 20.7354L11.3661 18.4049C11.7168 18.054 12.2832 18.054 12.6339 18.4049L14.9625 20.7354C15.529 21.3023 16.5 20.8974 16.5 20.0966V4.79964C16.491 3.80984 15.6818 3 14.6928 3ZM14.6928 17.928L13.9735 17.2081C12.7597 15.9934 11.0784 16.1464 10.0894 17.1362L9.2982 17.928V5.70846C9.2982 5.21356 9.7028 4.80864 10.1973 4.80864H13.7937C14.2882 4.80864 14.6928 5.21356 14.6928 5.70846V17.928Z' />
        </SvgIcon>
    );
});
